import React from 'react';

/**
 * props:
 * - children
 * - className
 */
export function PageTableCard({ children, className = '' }) {
    return (
        <div className={`private-page-card private-page-table-card ${className}`.trim()}>
            {children}
        </div>
    );
}

export default PageTableCard;